import React, { FC } from "react";
import stl from "./index.module.scss";
import "./index.scss";
import RCSelect, { SelectProps as RCSelectProps } from "rc-select";
import cn from "classnames";
import { getPopupContainer } from "../../shared/getPopupContainer";
import { Meta } from "rc-field-form/es/interface";

interface Props extends RCSelectProps {
  variant?: "default" | "unstyled" | "form";
  fieldMeta?: Meta;
}

const Select: FC<Props> = ({
  className,
  dropdownClassName,
  variant = "default",
  fieldMeta,
  ...props
}) => {
  let variantClass = "";
  switch (variant) {
    case "default": {
      variantClass = "";
      break;
    }
    case "unstyled": {
      variantClass = stl.blockUnstyled;
      break;
    }
    case "form": {
      variantClass = stl.form;
      break;
    }
  }

  let variantDropdownClass = "";
  switch (variant) {
    case "default": {
      variantDropdownClass = "";
      break;
    }
  }

  return (
    <RCSelect
      tabIndex={0}
      virtual={false}
      showSearch={false}
      menuItemSelectedIcon={false}
      getPopupContainer={getPopupContainer}
      {...props}
      dropdownClassName={cn(
        dropdownClassName,
        variantDropdownClass,
        stl.dropdown
      )}
      className={cn(className, variantClass, {
        [stl.errored]: fieldMeta && fieldMeta.errors.length > 0,
      })}
    />
  );
};

export default Select;
